import axios from "axios";
import axiosInstance from "../utils/axiosInstance";
import { TokenDecrypt } from "../utils/encryptionDecryption";

const mapToOptions = (data, labelKey = 'name', valueKey = 'code') => {
  return data.map(item => ({ label: item[labelKey], value: item[valueKey] }));
};
export const getCoursesFile = async () => {
  try {
    const response = await axiosInstance.get("course-files", {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response && response.data && response.data.encryptedData) {
      const decryptedData = TokenDecrypt(response.data.encryptedData);
      console.log("decryptedData",decryptedData);
      
      return decryptedData.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching Courses File:", error);
    throw new Error("Failed to fetch Courses File");
  }
}; 

export const getLanguages = async () => {
  try {
    const response = await axiosInstance.get("languages/list", {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return mapToOptions(response.data, 'title', 'id');
  } catch (error) {
    console.error("Error fetching Languages:", error);
    throw new Error("Failed to fetch Languages");
  }
};

export const getModels = async () => {
  try {
    const response = await axiosInstance.get("modules/listV2", {
      headers: {
        "Content-Type": "application/json",
      },
    });
     if (response?.data?.encryptedData) {
                const decryptedData = TokenDecrypt(response.data.encryptedData);
                if (decryptedData?.data) {
                  console.log("decryptedData?.data",decryptedData?.data);
                  return mapToOptions(decryptedData.data, "title", "id");
                }
              }
              return [];
  } catch (error) {
    console.error("Error fetching Models:", error);
    throw new Error("Failed to fetch Models");
  }
};

export const addCoursesFile = async (courseFileData) => {
  try {
    const response = await axiosInstance.post("course-files", courseFileData, {
      headers: {
          "Content-Type": "application/json",
      },
  });
  return response
  } catch (error) {
   console.error("Error adding Course File:", error);
  throw new Error("Failed add Course File");
  }
};

export const getTopics = async () => {
  try {
    const response = await axiosInstance.get("topics/list", {
      headers: {
        "Content-Type": "application/json",
      },
    });
     if (response?.data?.encryptedData) {
                const decryptedData = TokenDecrypt(response.data.encryptedData);
                if (decryptedData?.data) {
                  console.log("decryptedData?.data",decryptedData?.data);
                  
                  return mapToOptions(decryptedData.data, "title", "id");
                }
              }
              return [];
  } catch (error) {
    console.error("Error fetching topics:", error);
    throw new Error("Failed to fetch topics");
  }
};

export const getModelsById = async (courseId) => {
  try {
    const response = await axiosInstance.get(`modules/listV2?courseId=${courseId}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
     if (response?.data?.encryptedData) {
                const decryptedData = TokenDecrypt(response.data.encryptedData);
                if (decryptedData?.data) {
                  console.log("decryptedData?.data",decryptedData?.data);
                  
                  return mapToOptions(decryptedData.data, "title", "id");
                }
              }
              return [];
  } catch (error) {
    console.error("Error fetching Models:", error);
    throw new Error("Failed to fetch Models");
  }
};

export const getTopicById = async (moduleId) => {
  try {
    const response = await axiosInstance.get(`topics/listV2?moduleId=${moduleId}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
     if (response?.data?.encryptedData) {
                const decryptedData = TokenDecrypt(response.data.encryptedData);
                if (decryptedData?.data) {
                  console.log("decryptedData?.data",decryptedData?.data);
                  
                  return mapToOptions(decryptedData.data, "title", "id");
                }
              }
              return [];
  } catch (error) {
    console.error("Error fetching Topic:", error);
    throw new Error("Failed to fetch Topic");
  }
};

export const updateCoursesFile = async (courseFilId, courseFileData) => {
    try {
      const response = await axiosInstance.put(`course-files/${courseFilId}`,courseFileData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response;
    } catch (error) {
      console.error("Error updating Course File:", error);
      throw new Error("Failed to update Course File");
    }
  };

export const deleteContent = async (id) => {
  try {
    const response = await axiosInstance.delete(`/course-files/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Failed to Content Quiz.";
    console.error("Error in Question:", errorMessage);
    throw new Error(errorMessage);
  }
};